<template>
    <SwipeContainer
        title="Swipe right to save an outfit"
        subtext="We'll show you more outfits like these!"
        type="like" />
</template>

<script>
    import SwipeContainer from './swipe-container.vue';

    export default {
        components: {
            SwipeContainer
        }
    };
</script>
